<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";

/** Pages **/
import Home from '../pages/Home.vue'
import Login from '../pages/Login.vue'
import Task from '../pages/Task.vue'
import Customer from '../pages/Customer.vue'
import Worker from '../pages/Worker.vue'
import Product from '../pages/Product.vue'
import Report from '../pages/Report.vue'
import Invoice from '../pages/Invoice.vue'

/** Components **/
import HomeIndex from '../components/home/HomeIndex.vue'
import TaskIndex from '../components/task/TaskIndex.vue'
import TaskCreate from '../components/task/TaskCreate.vue'
import TaskShow from '../components/task/TaskShow.vue'
import TaskEdit from '../components/task/TaskEdit.vue'
import CustomerIndex from '../components/customer/CustomerIndex.vue'
import CustomerShow from '../components/customer/CustomerShow.vue'
//import CustomerCreate from '../components/customer/CustomerCreate.vue'
//import CustomerEdit from '../components/customer/CustomerEdit.vue'
import WorkerIndex from '../components/worker/WorkerIndex.vue'
import WorkerShow from '../components/worker/WorkerShow.vue'
import WorkerCreate from '../components/worker/WorkerCreate.vue'
import WorkerEdit from '../components/worker/WorkerEdit.vue'
import ProductIndex from '../components/product/ProductIndex.vue'
import ProductShow from '../components/product/ProductShow.vue'
import ReportIndex from '../components/report/ReportIndex.vue'
import InvoiceIndex from '../components/invoice/InvoiceIndex.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/login', component: Login },
    { path: '/home', component: Home,
      children: [
        { path: '', component: HomeIndex },
      ] },
    { path: '/', redirect: '/home' },
    { path: '*', redirect: '/' },
    { path: '/task', component: Task,
      children: [
        { path: '', component: TaskIndex, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] } },
        { path: 'new', component: TaskCreate, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] } },
        { path: ':id', component: TaskShow, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] } },
        { path: ':id/edit', component: TaskEdit, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] } }
      ] },
    { path: '/worker', component: Worker,
      children: [
        { path: '', component: WorkerIndex, meta: { requiredRoles: ['ROLE_ADMIN'] } },
        { path: 'new', component: WorkerCreate, meta: { requiredRoles: ['ROLE_ADMIN'] } },
        { path: ':id', component: WorkerShow, meta: { requiredRoles: ['ROLE_ADMIN'] } },
        { path: ':id/edit', component: WorkerEdit, meta: { requiredRoles: ['ROLE_ADMIN'] } }
      ] },
    { path: '/customer', component: Customer,
      children: [
        { path: '', component: CustomerIndex, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] }  },
        //{ path: 'new', component: CustomerCreate, meta: { requiredRoles: ['ROLE_ADMIN'] }  },
        { path: ':id', component: CustomerShow, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] }  },
        //{ path: ':id/edit', component: CustomerEdit, meta: { requiredRoles: ['ROLE_ADMIN'] }  }
      ] },
    { path: '/product', component: Product,
      children: [
        { path: '', component: ProductIndex, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] } },
        { path: ':id', component: ProductShow, meta: { requiredRoles: ['ROLE_USER', 'ROLE_ADMIN'] } },
      ] },
    { path: '/report', component: Report,
      children: [
        { path: '', component: ReportIndex, meta: { requiredRoles: ['ROLE_ADMIN'] } },
      ] },
    { path: '/invoice', component: Invoice,
      children: [
        { path: '', component: InvoiceIndex, meta: { requiredRoles: ['ROLE_ADMIN'] } },
      ] },
  ]
})

// check login state
router.beforeEach((to, from, next) => {
  // if not logged in
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('token');
  if (authRequired && !loggedIn) {
    return next('/login');
  }
  // check role
  const requiredRoles = to.meta.requiredRoles;
  const currentUser = store.state.auth.user;
  if (currentUser && requiredRoles && !requiredRoles.includes(currentUser.role.name)) {
    return next('/');
  }
  next();
})

export default router;
</script>
